﻿export function launchOption(path: string, options: Object, cbUrl: string): void {
    const $injector = angular.element(document).injector();
    const $rootScope = $injector.get('$rootScope');
    $injector.get('$location').url(path + (cbUrl ? '?cb=' + encodeURIComponent(cbUrl) : ''));
    if (!$rootScope.$$phase) {
        $rootScope.$apply();
    }
}
